module.exports = __webpack_public_path__ + "static/media/service-facade.0786a071.jpg";